import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store";
import EmailItemCard from "modules/Content/Shared/EmailItemCard";
import styled from "styled-components";
import {
  getEmailBrowserInCampaignList,
  resetEmailBrowserInCampaignList,
  resetEmailListInEmailBrowser,
  searchBrowserAssetsListInCampaign,
} from "../actions";
// import HistorySearch from "../../CurationHistory/Components/HistorySearch";
import { searchBrowserAssetsList } from "../actions";
import { useLocation } from "react-router-dom";
import { getQueryCampaignId, getQueryEmailId } from "modules/EmailBrowser/utils";
import InfiniteLoader from "modules/Common/Components/InfiniteLoader";
import EmailItemLoader from "modules/Common/Components/EmailItemLoader";
import CreateNewEmailButton from "modules/Common/Components/CreateNewEmailButton";
import ConfirmDialog from "modules/Common/Components/ConfirmDialog";

interface IAssetsInCampaignSidebar {
  isCuratedSidebarOpen: boolean;
}

const CampaignEmailsList: React.FC<IAssetsInCampaignSidebar> = (props: any) => {
  //* fetching asset Id to filter the asset from the All assets list
  const campaignId = getQueryCampaignId();
  const emailId = getQueryEmailId();
  let { pathname } = useLocation();
  const [search, setSearch] = useState(null);
  const [currentEmailIndex, setCurrentEmailIndex] = useState(-1);

  const page: number = useSelector((state: RootState) => state.emailBrowser?.emailsInCampaign?.page);
  const emails: any[] = useSelector((state: RootState) => state.emailBrowser?.emailsInCampaign?.data);
  const totalCount: number = useSelector((state: RootState) => state.emailBrowser?.emailsInCampaign?.totalCount);
  const emailsLoading: boolean = useSelector((state: RootState) => state.emailBrowser?.emailsInCampaign?.loading);
  const newEmailLoading: boolean = useSelector((state: RootState) => state.emailBrowser?.addNewEmail?.loading);
  const emptySearch: boolean = useSelector((state: RootState) => state.emailBrowser.searchFail);
  const showCurationMessage = useSelector((state: RootState) => state.user.assets);

  const [resolveRejectShowDialoge, setResolveRejectShowDialoge]: [any, any] = useState(undefined);
  const [showDeleteAssetDialoge, setShowDeleteAssetDialoge] = useState(false);

  // returns a promise for future state of confirm asset deletion dialoge
  const deletePromiseFuture = async () => {
    const promiseObj = new Promise((resolve, reject) => {
      setResolveRejectShowDialoge({
        res: resolve,
        rej: reject,
      });
    });
    return promiseObj;
  };

  useEffect(() => {
    if (resolveRejectShowDialoge && showDeleteAssetDialoge === false) {
      setShowDeleteAssetDialoge(true);
    }
  }, [resolveRejectShowDialoge]);

  //Triggered when user confirms the confirm dialoge of Email Deletion
  const emailDeleteHandler = () => {
    setShowDeleteAssetDialoge(false);
    resolveRejectShowDialoge.res();
    setResolveRejectShowDialoge(undefined);
  };

  //Triggered when user cancels the confirm dialoge of Email Deletion
  const onConfirmDialogCancel = () => {
    setShowDeleteAssetDialoge(false);
    resolveRejectShowDialoge.rej();
    setResolveRejectShowDialoge(undefined);
  };

  const clearAssetSearch = () => {
    if (pathname === "/campaigns/content") {
      searchBrowserAssetsListInCampaign(search, campaignId);
    } else {
      getEmailBrowserInCampaignList();
    }
  };

  const searchAssets = () => {
    if (pathname === "/campaigns/content") {
      //* Methods to Search for the assets in the campaign page
      if (search == null || search === "") {
        searchBrowserAssetsListInCampaign(search, campaignId);
      } else {
        searchBrowserAssetsListInCampaign(search, campaignId);
      }
    } else {
      if (search == null || search === "") {
        // getEmailBrowserList();
        loadMore();
      } else {
        searchBrowserAssetsList(search);
      }
    }
  };

  const loadMore = () => {
    let params = {
      limit: 10,
      offset: emails.length,
      campaign_id: campaignId,
    };
    getEmailBrowserInCampaignList(params);
  };

  useEffect(() => {
    if (emails.length === 0 && campaignId && !emailsLoading) {
      loadMore();
    }
    return () => {
      // resetEmailListInEmailBrowser();
      resetEmailBrowserInCampaignList();
    };
  }, []);

  useEffect(() => {
    if (emailId && emails.length > 0) {
      setCurrentEmailIndex(emails.findIndex((email) => email.emailId === emailId));
    }
  }, [emails, emailId]);

  return (
    <Wrapper>
      {showDeleteAssetDialoge && (
        <DialogWrapper>
          <ConfirmDialog
            cancel="Cancel"
            confirm="Delete"
            onConfirm={emailDeleteHandler}
            onCancel={onConfirmDialogCancel}
            // icon={whiteRoy}
            title={"Are you sure you want to delete this email?"}
            titleQuestion={null}
          />
        </DialogWrapper>
      )}

      <InfiniteLoader
        dataLength={emails.length}
        next={loadMore}
        hasMore={true}
        scrollableTarget="emailBrowserList"
        loader={
          emailsLoading ? (
            <>
              {[1, 2, 3, 4].map((item, index) => (
                <div key={index + item} className="margin-bottom-sm" style={{ marginRight: "10px" }}>
                  <EmailItemLoader />
                </div>
              ))}
            </>
          ) : (
            <></>
          )
        }
      >
        <div className="all-assets-list">
          {newEmailLoading ? (
            <div className="margin-bottom-sm" style={{ marginRight: "10px" }}>
              <EmailItemLoader />
            </div>
          ) : null}
          {/* adding the following code to show the current email in email browser at top */}
          {emails.length && currentEmailIndex !== -1 && currentEmailIndex < emails.length ? (
            <>
              <HeaderText>Current Email</HeaderText>
              <div
                key={emails[currentEmailIndex].emailId}
                className="margin-bottom-sm"
                style={{ marginRight: "10px" }}
                data-qa="qa-mail-sidebar"
              >
                <EmailItemCard
                  id={emails[currentEmailIndex].emailId}
                  active={true}
                  isCurrentEmail
                  data={emails[currentEmailIndex]}
                  onDelete={deletePromiseFuture}
                />
              </div>
            </>
          ) : null}
          {emailId ? (
            <AllEmailHeader>
              <HeaderText>All Emails</HeaderText>
              {/* <p>{totalCount > 0 ? totalCount - 1 : 0} emails</p> */}
            </AllEmailHeader>
          ) : null}
          {emails.map((item, key) => {
            if (emailId === item.emailId) return null;
            return (
              <div key={key} className="margin-bottom-sm" style={{ marginRight: "10px" }}>
                <EmailItemCard id={item.emailId} active={true} data={item} onDelete={deletePromiseFuture} />
              </div>
            );
          })}
        </div>
      </InfiniteLoader>
    </Wrapper>
  );
};

export default CampaignEmailsList;

const Wrapper = styled.div`
  .your-assets {
    display: flex;
    justify-content: space-between;
  }
  .all-assets-list {
    margin-top: 20px;
    min-height: 175px;
    .no-results {
      color: gray;
      padding-top: 10px;
      padding-left: 10px;
    }
    overflow-x: hidden;
  }
  .recent-heading {
    color: #67696a;
    font-family: "Roboto", sans-serif;
    font-size: 18px;
    letter-spacing: -0.38px;
    line-height: 34px;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 5px;
    @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 13px;
    }
  }
`;

const AllEmailHeader = styled.div`
  display: flex;
  align-items: center;
  margin-top: 24px;
  margin-bottom: -10px;
  h6 {
    margin-bottom: 0;
  }
  p {
    color: rgba(30, 194, 82, 1);
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    letter-spacing: -0.29px;
    text-align: left;
    margin: 0;
    margin-left: 14px;
  }
`;

const HeaderText = styled.h6`
  color: rgba(103, 105, 106, 1);
  font-family: "Roboto", sans-serif;
  font-size: 18px;
  font-weight: 500;
  font-style: normal;
  letter-spacing: -0.38px;
  text-align: left;
  margin: 0;
  margin-bottom: -10px;
`;

const DialogWrapper = styled.div`
  z-index: 17;
  top: 50%;
  left: 50%;
  position: fixed;
`;
